import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';
import InitAutoplay from './initAutoplay';

Swiper.use([Pagination, Navigation, Autoplay]);

let stepsSlider = null;

const stepsMobileConfig = {
  pagination: {
    el: '.er_steps__inner__mobile__pagination',
    clickable: true,
    spaceBetween: 50,
    resizeObserver: true,
    grabCursor: true,
  },
  navigation: {
    nextEl: '.er_steps__inner__mobile__arrows__next',
    prevEl: '.er_steps__inner__mobile__arrows__prev',
  },
};

document.querySelector('.er_steps__inner__mobile__arrows__next').addEventListener('click', () => {
  stepsSlider.slideNext();
});

document.querySelector('.er_steps__inner__mobile__arrows__prev').addEventListener('click', () => {
  stepsSlider.slidePrev();
});

const initSlider = () => {
  if (window.matchMedia('(max-width: 1024px)').matches && !!!stepsSlider) {
    stepsSlider = new Swiper('.er_steps__inner__mobile_container', stepsMobileConfig);
  }

  if (stepsSlider && window.matchMedia('(max-width: 1024px)').matches) {
    window.addEventListener('scroll', () => {
      InitAutoplay(stepsSlider, 'er_steps', 6000);
    });
  }
};

export default () => {
  initSlider();
  window.addEventListener('resize', initSlider, false);
};
